var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { config } from "./config";
import { templater } from "./templater";
import { utilities } from "../utilities/utilities";
/**
 * Base Component class to be extended by all UI components.
 */
var Component = /** @class */ (function () {
    function Component(args) {
        var _this = this;
        var _a, _b;
        this.events = {};
        // setOptions = () : void => {
        //     // this.options = t
        //     // this.options =  {...config.default.options[this.name], ...this.options}
        // };
        // setEvents = () : void => {
        //     // this.events =  {...config.default.events[this.name], ...this.events}
        // }
        this.setElement = function () {
            if (!_this.element)
                _this.element = _this.compose();
        };
        this.setComponentInstance = function () {
            _this.componentInstance = _this.initialiseInstance();
        };
        this.attachEventListeners = function () {
            Object.keys(_this.events).forEach(function (key) {
                if (!_this.events[key] || _this.name == 'collapse')
                    return;
                var element;
                if (_this.name == 'collapse' && Array.isArray(_this.element)) {
                    element = _this.element[1];
                    return;
                }
                else if (_this.name == 'wysiwyg') {
                    element = _this.element[1].querySelector('.wysiwyg-content');
                }
                else {
                    element = _this.element;
                }
                element.addEventListener("".concat(key, ".").concat(_this.implementation.eventSuffix), _this.events[key]);
            });
        };
        this.initialiseInstance = function () {
            if (!_this.element)
                return;
            // this.setOptions();
            var element;
            if (_this.name == 'collapse' && Array.isArray(_this.element)) {
                element = _this.element[1];
            }
            /* added 02/11/2023 */
            else if (_this.name == 'dropdown') {
                element = _this.element.querySelector('.toggle');
            }
            /* added 02/11/2023 */
            else {
                element = _this.element;
            }
            if (_this.name == 'toast') {
                return new mdb.Toast(element, _this.options);
                // return new mdb.Toasty(element, this.options)
            }
            // if(this.name == "dropdown"){
            //     console.log('dropdown')
            //     console.log(new mdb.Dropdown(this.element, this.options))
            // }
            if (_this.name == "toast") {
                // console.log(config.default.implementation.find(x => x.name == this.name).initialiser, 'should be TOAST');
                // const testToast = utilities.html`
                //     <div style="" class="toast toast-fixed" role="alert" aria-live="assertive" aria-atomic="true">
                //         <div class="toast-header">
                //             <button type="button" class="btn-close" data-mdb-dismiss="modal" aria-label="Close"></button>
                //         </div>
                //         <div class="toast-body">
                //             body
                //         </div>
                //     </div>
                // `;
                // document.body.appendChild(testToast)
                // console.log(new mdb.Toast(testToast), 'fresh empty toast')
            }
            var result = new mdb["".concat(config.default.implementation.find(function (x) { return x.name == _this.name; }).initialiser)](element, _this.options);
            return result;
        };
        this.compose = function () {
            var _a, _b;
            if ((_a = _this.composer) === null || _a === void 0 ? void 0 : _a.template) {
                if (typeof _this.composer.template === 'function') {
                    var template_1 = _this.composer.template(_this);
                    return typeof template_1 === 'string' ? utilities.html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", ""], ["", ""])), template_1) : template_1;
                }
                ;
            }
            var template = (_b = templater === null || templater === void 0 ? void 0 : templater[_this.name]) === null || _b === void 0 ? void 0 : _b.call(templater, _this);
            if (!template) {
                throw new Error('No template defined in cerberus.templater! And/ or no custom template provided!');
            }
            else {
                return template;
            }
            ;
        };
        this.beforeInitialise = function () {
            //SET FROM WITHIN CHILD COMPONENTS - DO NOT DELETE
        };
        this.options = (_a = args === null || args === void 0 ? void 0 : args.options) !== null && _a !== void 0 ? _a : {};
        this.events = (_b = args === null || args === void 0 ? void 0 : args.events) !== null && _b !== void 0 ? _b : {};
        if (args === null || args === void 0 ? void 0 : args.element) {
            this.element = args.element;
        }
        this.composer = args === null || args === void 0 ? void 0 : args.composer;
    }
    Object.defineProperty(Component.prototype, "implementation", {
        get: function () {
            var _this = this;
            return config.default.implementation.find(function (x) { return x.name == _this.name; });
        },
        enumerable: false,
        configurable: true
    });
    Component.prototype.init = function () {
        this.setComponentInstance();
        this.beforeInitialise();
        this.attachEventListeners();
    };
    return Component;
}());
export { Component };
var templateObject_1;
